import { Col, Row } from "react-bootstrap";

import {
  buttonNameConstants,
  buttonTypeConstants,
} from "../../../../constants";
import Button from "../../../../shared/components/Buttons/Button";

const CashPayment = ({
  amountToPay,
  spinnerArray,
  currentStore,
  storeDevices,
  paymentDevice,
  transactionData,
  setPaymentMethod,
  handleOtherPayment,
  handleThirdPartyPayment,
  handleCreditCardPayment,
  handleTransactionCancel,
  activeCardPaymentTypeProp,
  handleCancelButtonClick = () => {},
}) => {
  const handleContinueButtonClick = () => {
    handleOtherPayment();
  };

  const handleCancelBtnClick = () => {
    setPaymentMethod("");
  };
  return (
    <div className="payment-cash-card-wrapper">
      <Row className="m-0">
        <Col
          md={12}
          className="d-flex justify-content-between align-items-center"
        >
          <span className="cash-heading">Other</span>
        </Col>
        <Col md={12}>
          <div className="w-100 p-3 d-flex justify-content-center align-items-center">
            <span className="w-100 p-3 text-center">
              Collect payment using your Other payment source
            </span>
          </div>
          <Button
            type="button"
            label={buttonNameConstants.CONTINUE}
            handleClick={() => {
              handleContinueButtonClick();
            }}
            className="w-100 mt-2"
          />
          <Button
            type="button"
            label={buttonNameConstants.CANCEL}
            handleClick={handleCancelBtnClick}
            buttonType={buttonTypeConstants.GHOST_BUTTON}
            className="w-100 mt-2"
          />
        </Col>
      </Row>
    </div>
  );
};

export default CashPayment;
